import React, {useRef} from 'react';
import {UsePermissions} from "../../../hooks/usePermissions";
import {UseLoader} from "../../../hooks/useLoader";
import {convertirModena, formatFecha} from "../../../shared/utils/utils";
import {Toast} from "primereact/toast";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {confirmDialog} from "primereact/confirmdialog";
import {agregarFechaPagos, agregarObserDeduccion, eliminarLiquidacion} from "../../../api/liquidacionDeduccion.service";
import {InputText} from "primereact/inputtext";


export const TableDeduccionesAsociados = ({deducciones, reload, fecha}) => {

    const [permisos] = UsePermissions()

    const [handleLoad] = UseLoader();
    const toast = useRef(null);

    const valorPagoBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor);
    }

    const valorTypoBodyTemplate = (rowData) => {
        if (rowData.ded_indiv === 'S') {
            return 'Individual'
        }
        return 'Automático'
    }

    const eliminar = (rowData) => {
        confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () => {
                handleLoad(true);
                const response = await eliminarLiquidacion(rowData);
                handleLoad(false);

                if (response.estado !== 200) {
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Alerta',
                        detail: response.mensaje,
                        life: 3000
                    });
                    return;
                }

                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                reload()
            }
        });
    }

    const agregarFechaPago = (rowData) => {
        confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () => {
                handleLoad(true);
                const payLoad = {
                    id: rowData.id,
                    fecha
                }
                const response = await agregarFechaPagos(payLoad);
                handleLoad(false);

                if (response.estado !== 200) {
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Alerta',
                        detail: response.mensaje,
                        life: 3000
                    });
                    return;
                }

                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                reload()
            }
        });
    }

    const header = (
        <div className="flex align-items-center  ">
            <p className="p-2  text-sm"> Total registros: {deducciones.length}</p>
        </div>
    );

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn danger-color-btn"
                    type="button"
                    onClick={() => eliminar(rowData)}>
                    <i className="fa fa-trash"/>
                </button>

                {rowData.fecha_pago === 'N'  &&
                    <button
                        disabled={(!permisos.editar)}
                        className="btn primary-color-btn"
                        type="button"
                        onClick={() => agregarFechaPago(rowData)}>
                        <i className="fa fa-save"/>
                    </button>}
            </div>
        );
    }

    const valorTotal = () => {
        let total = 0;
        for (let ded of deducciones) {
            total += ded.valor === '' ? 0 : parseFloat(ded.valor);
        }
        return convertirModena(total);
    }

    let footerGroup =
        <ColumnGroup>
            <Row>
                <Column footer="Total:" colSpan={1} footerStyle={{marginLefth: '10px', fontSize: '.9em'}}/>
                <Column colSpan={4} footer={valorTotal} footerStyle={{fontSize: '.9em'}}/>
            </Row>

        </ColumnGroup>;

    const textEditor = (options) => {
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)}/>;
    }

    const onCellEditComplete = async (e) => {
        let {rowData, newValue, field, originalEvent: event} = e;
        if (newValue.trim().length > 0) {
            rowData[field] = newValue;
            handleLoad(true);
            const response = await agregarObserDeduccion(rowData);
            handleLoad(false);

            if (response.estado !== 200) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Alerta',
                    detail: response.mensaje,
                    life: 3000
                });
                return;
            }

            toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
            reload()
        } else {
            event.preventDefault();
        }
    }
    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <ContainerTable>
                <DataTable
                    showGridlines
                    resizableColumns
                    footerColumnGroup={footerGroup}
                    columnResizeMode="expand"

                    header={header}
                    size="small"
                    scrollable scrollHeight="400px"
                    value={deducciones}

                    responsiveLayout="scroll">
                    <Column header="Eliminar" style={{fontSize: ".8em"}} body={actionTemplate}></Column>
                    <Column field="valor" header="Valor" sortable filter body={valorPagoBodyTemplate}
                            showFilterMatchModes={false}
                    >
                    </Column>
                    <Column field="observaciones" sortable filter header="Observaciones" showFilterMatchModes={false}
                            onCellEditComplete={onCellEditComplete}
                            editor={(options) => textEditor(options)}
                    ></Column>
                    <Column field="fondo" sortable filter header="Fondo" showFilterMatchModes={false}
                    ></Column>
                    <Column field="ded_indiv" sortable filter header="Tipo descuento" body={valorTypoBodyTemplate}
                            showFilterMatchModes={false}
                    >
                    </Column>

                </DataTable>
            </ContainerTable>
        </>
    );
};


